import React from "react";
import { Subscription } from "./Subscription";
import styles from "./Subscriptions.module.scss";
import { useSubscriptions } from "features/patientDashboard/hooks/useSubscriptions";
import { Card } from "components/Card";
import { Patient } from "types/patient";
import { Subscription as SubscriptionType } from "types/Subscription";

export const Subscriptions: React.FC<{
  patient: undefined | Partial<Patient>;
}> = ({ patient }) => {
  const patientId = patient.id;
  const { subscriptions } = useSubscriptions(patientId);

  if (subscriptions === undefined || subscriptions.length === 0) {
    return null;
  }
  subscriptions.sort((a, b) => {
    return new Date(a.nextPurchaseDate) - new Date(b.nextPurchaseDate);
  });

  const activeSubcription = [];
  const failedSubscription = [];
  const otherSubscription = [];

  for (const key in subscriptions) {
    const subs = subscriptions[key];
    if (
      subs.subscriptionStatus === "PAYMENT FAILED" ||
      subs.cycleStatus === "payment_error"
    ) {
      failedSubscription.push(subs);
    } else if (subs.subscriptionStatus === "ACTIVE") {
      activeSubcription.push(subs);
    } else {
      otherSubscription.push(subs);
    }
  }

  const newSortedSubscriptions = failedSubscription.concat(
    activeSubcription,
    otherSubscription
  );
  return <UnconnectedSubscriptions subscriptions={newSortedSubscriptions} />;
};

export const UnconnectedSubscriptions: React.FC<{
  subscriptions: SubscriptionType[];
}> = ({ subscriptions }) => (
  <>
    <Card className={styles.card}>
      <h4 className={styles.headline}>Subscriptions</h4>
      <hr className={styles.headlineSeparator} />
      <ul className={styles.list}>
        {subscriptions.map((subscription, i) => (
          <li key={subscription.subscriptionId}>
            {i > 0 ? <hr className={styles.separator} /> : null}{" "}
            {/* Insert a separator between each element */}
            <Subscription subscription={subscription} />
          </li>
        ))}
      </ul>
    </Card>
  </>
);
